module.exports = __webpack_public_path__ + "img/growthAbility8.1d006a45.png";